import ButtonCircle from '../../../shared/components/button_circle';
import './styles.scss';
import { selectMainState, useDispatch } from '../../../stateManagement/redux';
import ButtonBig from '../../../shared/components/button_big'
import { useDropzone } from 'react-dropzone'
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { consolidateFilesLocal } from '../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { FileCustom, UploadFileProps } from './interfaces';
import { UploadModal } from "./upload-modal";
import { FileRow } from "./upload-modal/fileRow";
import { useNavigate } from 'react-router-dom';
import { getListOfLocationsByProject, getListOfUsers, getOriginFlowByModule } from 'src/shared/util/requestDataServer';
import { OriginalFlowUploadInterface } from 'src/stateManagement/redux/slices/gerencia_tecnica/interfaces';



export const ConsolidateFileModule = (props: UploadFileProps) => {

    const [originalFlowUploadList, setOriginalFlowUploadList] = useState<OriginalFlowUploadInterface[]>([])
    
    const [listOfUsers, setlistOfUsers] = useState<any[]>([])

    useEffect(() => {
        getOriginFlowByModule("uploadV2")
        .then((data) => {
            setOriginalFlowUploadList(data)
        }).catch((error) => {
            console.log(`[Error Request Origin Flow by Module]: ${error}`)
        }
        )

        getListOfUsers().then((data) => {
            setlistOfUsers(data)
        }).catch((error) => {
            console.log(`[Error Request List of Users]: ${error}`)
        })

    }, [])

    
    const [locations, setLocations] = useState<any[]>([])

    const navigate = useNavigate();

    const [filesExcel, setFilesExcel] = useState<FileCustom[]>([])

    const [showUploadModal, setShowUploadModal] = useState(false)

    const [originalFlow, setOriginalFlow] = useState<any>(undefined)


    const onDropExcel = useCallback((acceptedFiles: File[]) => {

        acceptedFiles.map(file => {
            const fileFormat: FileCustom = {
                ...file,
                fileName: file.name,
                fileType: file.type,
                fileSize: `${(file.size / 1024).toFixed(2)} KB`,
                status: 'No Cargado',
                file: file,
                typeOfFile: 'excel',
            }
            // setUploadedFiles(prevFiles => [...prevFiles, fileFormat]);
            setFilesExcel(prevFiles => [...prevFiles, fileFormat]);
        })

    }, []);


    const removeFileExcel = (file: FileCustom) => {
        setFilesExcel(prevFiles => prevFiles.filter(f => f !== file));
    }

    const { getRootProps: getRootPropsExcel, getInputProps: getInputPropsExcel, isDragActive: isDragActiveExcel, open: openExcel } = useDropzone({ onDrop: onDropExcel, noClick: true });

    const startUploadFiles = () => {
        if (filesExcel.length === 0) {
            alert('Debes subir al menos un archivo Excel')
            return
        }

        if (originalFlow === '' || originalFlow === undefined) {
            alert('Debes seleccionar un tipo de Tecnologia')
            return
        }

        setShowUploadModal(true)
    }

    if (showUploadModal) {
        return <UploadModal 
                close={() => setShowUploadModal(false)} 
                originalFlow={originalFlow} 
                originalFlowSelected={originalFlowUploadList.find(f => f.id === originalFlow)}
                excelFile={filesExcel} 
                listOfLocations={locations}
                setLocations={setLocations}
                listOfUsers={listOfUsers}
                />
    }

    return (
        <div className='Upload_files_container'>
            <div className='Upload_files_container_header'>
                <ButtonCircle icon="/assets/icons/back.svg" iconHeight={50} iconWidth={50} onClick={() => navigate('/gto/upload')} />
                <div className='Upload_files_container_title'>{props.title}</div>
            </div>
            {/* Body */}
            <div className="Upload_files_container_body">
                {/* Instrucciones */}
                <div className='Upload_files_container_instructions_section' >
                    <div className='Upload_files_container_instructions_section_title'>{props.title}</div>
                    <ul className='Upload_files_container_instructions_section_instructions_list'>
                        {props.templateUrl && (
                            <li className='Upload_files_container_instructions_section_instructions_list_download'>
                                <a href={props.templateUrl} target='blank' download>Descargar plantilla activa para la actividad</a>
                            </li>
                        )}
                        {props.instructions?.map((instruction, index) => (
                            <li key={index} className='Upload_files_container_instructions_section_instructions_list_item'>
                                {instruction}
                            </li>
                        ))}
                    </ul>
                    {props.alertInstructions && (
                        <div className='Upload_files_container_instructions_section_detail'>
                            <img src="/assets/icons/info.svg" width={20} height={20} alt='' />
                            {props.alertInstructions}
                        </div>
                    )}
                </div>
                {/* Formulario */}
                <div className='Upload_files_container_form_section'>
                    <div className='Upload_files_container_form_title'>Campos Requeridos</div>

                    <div>
                        <div className="consolidate_files_container_custom_input">
                            <label htmlFor="file">Tipo de tecnologia : </label>
                            <select id="activity" name="activity" className='Upload_files_container_form_section_select' value={originalFlow} onChange={(e) => setOriginalFlow(e.target.value)}>
                                <option value=''>Selecciona una opcion</option>
                                {originalFlowUploadList?.map((f, index) => <option key={index} value={f.id}>{f.name}</option>)}
                            </select>
                        </div>
                    </div>

                    {/* files container Excel */}
                    <>
                        <div className='Upload_files_container_custom_input'>
                            <label htmlFor="file">Archivos Excel:</label>
                            <ButtonCircle icon="/assets/icons/attach_file.svg" iconHeight={20} iconWidth={20} onClick={openExcel} />
                        </div>
                        <div className='Upload_files_container_member_list_container' {...getRootPropsExcel()}>
                            <input {...getInputPropsExcel()} />
                            {filesExcel.length > 0
                                ? filesExcel.map((file, index) => <FileRow key={index} file={file} onRemove={removeFileExcel} />)
                                : <div className='Upload_files_container_nofiles_section'>
                                    {!isDragActiveExcel &&
                                        <>
                                            <img src='/assets/icons/upload_icon.svg' width={70} height={70} alt='' />
                                            <div>Arrastra o suelta aquí el archivo para subirlo o selecciona desde tus archivos</div>
                                            <ButtonBig text='Cargar Archivos' onClick={openExcel} />
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </>
                    {/* save button */}
                    <div className='Upload_files_container_save_button'>
                        <ButtonBig text='Consolidar' icon='/assets/icons/merge.svg' onClick={() => startUploadFiles()} />
                    </div>
                </div>
            </div>
        </div>
    )
}